module.exports = __webpack_public_path__ + "img/05h_Buy_Scene.4197f079.jpg";